import React from 'react';
import clsx from 'clsx';

export interface ChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    selected?: boolean;
    icon?: React.ReactNode;
}

/** 36px pill: category filters, quick-cash amounts, date ranges. */
export const Chip: React.FC<ChipProps> = ({ selected = false, icon, className, children, type = 'button', ...props }) => (
    <button
        type={type}
        aria-pressed={selected}
        className={clsx(
            'inline-flex h-9 shrink-0 items-center gap-[7px] whitespace-nowrap rounded-pill px-4 text-sm font-bold leading-none transition-colors duration-200',
            selected
                ? 'bg-primary-500 text-white border border-primary-500 hover:bg-primary-700'
                : 'bg-surface-card text-ink-primary border border-line hover:border-primary-500 hover:bg-brandsoft',
            'disabled:opacity-45 disabled:pointer-events-none',
            className,
        )}
        {...props}
    >
        {icon && <span className="inline-flex [&>svg]:w-4 [&>svg]:h-4">{icon}</span>}
        {children}
    </button>
);
export default Chip;
